exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._30WzcOrPBaNwG8nUHM-8RW {\n  max-width: 519px;\n  background-color: #FFFFFF;\n  border: 1px solid #E0E0E0;\n  padding: 40px;\n  position: relative;\n}\n@media (max-width: 540px) {\n  ._30WzcOrPBaNwG8nUHM-8RW {\n    width: 100%;\n    padding: 24px 16px;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"box": "_30WzcOrPBaNwG8nUHM-8RW"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--4-2!./node_modules/postcss-loader/lib??postcss!./node_modules/less-loader/dist/cjs.js!./src/client/Components/AuthLayoutContainer/AuthLayoutContainer.css
// module id = 1231
// module chunks = 33 35 37 38 39 40 42 43 44 45 46